<template>
  <div v-if="login.customer.id">
    <OneColumnPageLayout>
      <OutSideTitleCard :title="$t('Customer.Customer')">
        <v-row>
          <v-spacer />
          <IconButton
            class="ma-0"
            :label="$t('Edit')"
            icon="mdi-pencil"
            @click="openEditDialog(login.customer)"
          />
        </v-row>

        <h1>{{ login.customer.customer_name }}</h1>

        <v-row class="my-4 mx-3">
          <v-icon
            size="36"
            color="grey-darken-1"
          >
            mdi-map-marker
          </v-icon>
          <div class="text-h6 font-weight-regular mx-3">
            <p>{{ $filters.japanesePostalCode(login.customer.postal_code) }}</p>
            <p>{{ login.customer.address1 }}</p>
            <p v-if="login.customer.address2">
              {{ login.customer.address2 }}
            </p>
          </div>
        </v-row>

        <v-row class="mx-3 my-4">
          <v-icon
            size="36"
            color="grey-darken-1"
          >
            mdi-phone
          </v-icon>
          <div class="text-h6 font-weight-regular mx-3">
            {{ login.customer.tel }}
          </div>
        </v-row>
      </OutSideTitleCard>

      <div class="mt-5">
        <h2 class="text-accent mb-3">
          {{ $t('Customer.AvailableServices') }}
        </h2>
        <CustomerAvailableServicesContent />
      </div>
    </OneColumnPageLayout>

    <!-- 編集ダイアログ -->
    <EditCustomerDialog
      v-model="editDialog"
      :current-data="editCurrentData"
      @reload="get()"
    />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import OutSideTitleCard from '@/components/parts/card/OutSideTitleCard'
  import IconButton from '@/components/parts/button/IconButton'
  import EditCustomerDialog from '@/components/dialogs/editCustomerDialog'
  import _ from 'lodash'
  import CustomerAvailableServicesContent from '@/components/content/CustomerAvailableServicesContent'
  import OneColumnPageLayout from '@/components/pages/layouts/OneColumnPageLayout'

  export default {
    components: {
      OneColumnPageLayout,
      CustomerAvailableServicesContent,
      EditCustomerDialog,
      IconButton,
      OutSideTitleCard
    },
    data: () => ({
      editDialog: false,
      editCurrentData: null
    }),
    computed: {
      ...mapGetters(['ui', 'login'])
    },
    watch: {
      'login.profile' () {
        this.get()
      }
    },
    methods: {
      get () {
        this.$http.get(`customers/${this.login.profile.customer}/`).then((res) => {
          this.$store.dispatch('login', { customer: res.data })
        })
      },
      openEditDialog (currentData) {
        this.editCurrentData = null
        if (currentData) {
          this.editCurrentData = _.cloneDeep(currentData)
        }
        this.editDialog = true
      }
    }
  }
</script>
